// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__cPIPq","inner":"Footer_inner__1wPNy"};